define([
    'spin',
    'jquerySpin'
], function() {
    var _self;
    // console.log('_site');

    // obj
    _self = {
        breakpoints: {
            xs: 420,
            sm: 768,
            md: 992,
            lg: 1200,
            xl: 1600,
            ds: 1920,
        },
        // scrolling: false,
        // cache: {},
        timeout: {},
        // templates: {},
        spin: {
            lines: 13,
            length: 1,
            width: 5,
            radius: 6,
            scale: 1,
            corners: 1,
            color: '#FFF',
            opacity: 0.25,
            rotate: 0,
            direction: 1,
            speed: 1,
            trail: 60,
            fps: 20,
            zIndex: 2e9,
            className: 'spinner',
            top: '50%',
            // left: '0',
            left: '50%',
            shadow: false,
            hwaccel: false,
            position: 'absolute'
        }
    };

    // -------------------
    // BINDS
    // -------------------

    return _self;
});
